import { LockOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import React from 'react';

import { ProjectConnectionFragment } from './graphql/fragments/ProjectConnectionFragment';
import { ProjectFragment } from './graphql/fragments/ProjectFragment';
import { ProjectListFragment } from './graphql/fragments/ProjectListFragment';
import { ProjectQuery } from './graphql/ProjectQuery';
import { DynamicList } from './index';
import { DynamicFilterListType, ProjectType } from './types';

interface IProjectSelect {
    onChange?: (value: string | string[]) => void;
    disabled?: boolean;
    filterList?: DynamicFilterListType[];
    mode?: 'multiple';
    style?: React.CSSProperties;
    // localFilters?: RowsFilterType;
    maxTagCount?: number | 'responsive';
    disabledListProject?: string[];
    filterFlexible?: string;
}

const outProjectSelect = React.forwardRef<any, IProjectSelect>(
    ({ onChange, disabledListProject, ...restProps }, ref) => {
        const renderOptionLabel = (item: ProjectType, label: string) => {
            return (
                <Flex justify={'space-between'}>
                    <span>{label}</span>
                    {disabledListProject?.includes(item.id) && <LockOutlined />}
                </Flex>
            );
        };

        return (
            <DynamicList
                ref={ref}
                query={ProjectQuery}
                fragmentList={ProjectListFragment}
                fragmentConnection={ProjectConnectionFragment}
                fragment={ProjectFragment}
                nameQuery={'projects'}
                fields={['name', 'number'] as (keyof ProjectType)[]}
                template={'name [number]'}
                onChange={(value: string | string[]) => {
                    onChange?.(value);
                }}
                // filterList={[
                //     {
                //         fieldName: 'status',
                //         filters: [LIST_TASK_GROUP_STATUS, LIST_STATUS_PROJECT],
                //     },
                // ]}
                renderOptionLabel={renderOptionLabel}
                disabledList={new Set(disabledListProject)}
                {...restProps}
            />
        );
    },
);

export default outProjectSelect;
